import {useEffect, useState} from 'react';

type WindowSize = {
    innerWidth: number;
    innerHeight: number;
};

function getSize(): WindowSize {
    if (typeof window === 'undefined') {
        return {
            innerWidth: 1920,
            innerHeight: 1080,
        };
    }

    return {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
    };
}

export function useWindowSize(): WindowSize {
    const [size, setSize] = useState(getSize());

    useEffect(() => {
        const r = () => {
            requestAnimationFrame(() => setSize(getSize()));
        };
        window.addEventListener('resize', r);

        return () => {
            window.removeEventListener('resize', r);
        };
    }, []);

    return size;
}
